import React from 'react';
const Footer = () => (
  <section className="Podval" id="podval">
    <div className="row_podval">
      <div className="block_podval">
        <h3>"ПариМосква"</h3>
        <h4>Санкт-Петербург и Ленинградская область</h4>
      </div>
      <div className="block_podval">
        <h3>Страницы</h3>
        <a href="#header">Главная</a>
        <a href="#About">Наши торты</a>
        <a href="#wrapper">Заказ</a>
      </div>
      <div className="block_podval">
        <h3>Свяжитесь с нами:</h3>
        <div className="line">
          <a href="https://instagram.com/parimoskva" className="fa fa-instagram"> parimoskva</a>
          <a href="tel:+79811070307">+7(981)1070307</a>
        </div>
      </div>
    </div>
  </section>
);
export default Footer;